import { resolveUsers } from './user';
import { getCurrentUser } from '../services/store-service';

const getUsername = (user, full) => {
    if (!user) {
        return '';
    }

    if (!full) {
        return (user.name ? user.name.split(' ')[0] : user.email) || '';
    }

    return (user.name || user.email || '');
}

const getUserIds = (users, options, currentUser) => {
    const userIds = users.map(user => user.id || user);

    if (options.withCurrentUser || !currentUser) {
        return userIds;
    }

    return userIds.filter(userId => userId !== currentUser.id);
}

export const getChatTitle = (users = [], discussion, options = {}) => {
    if (!discussion) {
        return '';
    }

    if (!options.forceUsers && discussion.name) {
        return discussion.name;
    }

    const currentUser = getCurrentUser();
    const userIds = getUserIds(users, options, currentUser);
    const resolvedUsers = resolveUsers({ userIds });

    switch (resolvedUsers.length) {
        case 0:
            if (discussion.type === 'group') {
                return 'Untitled chat';
            }

            if (users.length) {
                return currentUser.name || currentUser.email;
            }

            return 'New chat';

        case 1:
            return getUsername(resolvedUsers[0], true);

        case 2:
            return `${getUsername(resolvedUsers[0])} and ${getUsername(resolvedUsers[1])}`;

        case 3:
            return `${getUsername(resolvedUsers[0])}, ${getUsername(resolvedUsers[1])} and ${getUsername(resolvedUsers[2])}`;

        default:
            return `${getUsername(resolvedUsers[0])}, ${getUsername(resolvedUsers[1])} and ${resolvedUsers.length - 1} others`;
    }
}
